import {
  jb_article_wide_css_default
} from "./chunk.EBUX4XSQ.js";
import {
  Linkable,
  Spaceable
} from "./chunk.P6YYTXAQ.js";
import {
  Rt
} from "./chunk.LQ2ZH6PS.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  D,
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-article-wide/jb-article-wide.ts
var JbArticleWide = class extends Linkable(Spaceable(r)) {
  constructor() {
    super(...arguments);
    this.picture = void 0;
  }
  connectedCallback() {
    super.connectedCallback();
    this.link.name = this.articleTitle;
  }
  _getContentSpacingProperties() {
    return { colsMdUp: "none", horizontal: "full-width-sm-down", type: "article-wide" };
  }
  _renderArticleWide() {
    return ke`<article class="${Rt({ headline: !!this.headline })}">
      <div class="row">
        <div class="item item--left">
          <a
            data-linkable
            class="link"
            >${this._renderTeaserHeader()}</a
          >
          <jb-teaser-meta
            .date=${this.teaserMeta.date}
            .category=${this.teaserMeta.category}
            .link=${this.teaserMeta.link ? this.teaserMeta.link : this.link}
            .time=${this.teaserMeta.time}
          ></jb-teaser-meta>
        </div>
        <div class="item item--right">
          <a data-linkable>${this._renderPreview()}</a>
        </div>
      </div>
    </article>`;
  }
  _renderPreview() {
    if (this.picture) {
      return ke`<jb-thumbnail
        .aspect=${"aspect_3by2"}
        .backgroundPicture=${{ ...this.picture, alt: this.articleTitle }}
        .type=${"picture"}
      ></jb-thumbnail>`;
    }
    return null;
  }
  _renderTeaserHeader() {
    return ke`<jb-teaser-header
      .maxLines=${4}
      .teaser=${this.articleTeaser}
      .headline=${this.articleTitle}
    ></jb-teaser-header>`;
  }
  render() {
    return ke`
      <section>
        ${this.headline ? ke`
              <div class="headline-wrap">
                <jb-section-headline
                  .headline=${this.headline}
                  .languageBadge=${this.languageBadge}
                ></jb-section-headline>
              </div>
            ` : D}
        ${this._renderArticleWide()}
      </section>
    `;
  }
};
JbArticleWide.styles = jb_article_wide_css_default;
__decorateClass([
  n()
], JbArticleWide.prototype, "articleTeaser", 2);
__decorateClass([
  n()
], JbArticleWide.prototype, "articleTitle", 2);
__decorateClass([
  n()
], JbArticleWide.prototype, "headline", 2);
__decorateClass([
  n()
], JbArticleWide.prototype, "languageBadge", 2);
__decorateClass([
  n({ type: Object })
], JbArticleWide.prototype, "picture", 2);
__decorateClass([
  n({ type: Object })
], JbArticleWide.prototype, "teaserMeta", 2);
JbArticleWide = __decorateClass([
  customElement("jb-article-wide")
], JbArticleWide);

export {
  JbArticleWide
};
